import { render, staticRenderFns } from "./brand-add.vue?vue&type=template&id=24e02504&"
import script from "./brand-add.vue?vue&type=script&lang=js&"
export * from "./brand-add.vue?vue&type=script&lang=js&"
import style0 from "./brand-add.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24e02504')) {
      api.createRecord('24e02504', component.options)
    } else {
      api.reload('24e02504', component.options)
    }
    module.hot.accept("./brand-add.vue?vue&type=template&id=24e02504&", function () {
      api.rerender('24e02504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/data-dictionary/consumable-brands/brand-add.vue"
export default component.exports